(ns hypnos.consumer.panels.consult.eye-dryness
  "The consult eye dryness (after a night of using PAP therapy) step."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :eye-dryness :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :eye-dryness :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  []
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.eye-dryness/statement)]]])

(defn eye-dryness-field
  [state]
  [:div.field.has-check ;; .is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.eye-dryness/question))]]
   [:div.field-body
    [:div.field ;; .is-grouped-multiline.is-grouped
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "eye-dryness"
                      :checked   (true? (get-in @state [:consult :consult/eye-dryness? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/eye-dryness? :value])
                                         new-value (when (-> e .-target .-checked) true)
                                         changed?  (or (get-in @state [:consult :consult/eye-dryness? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/eye-dryness? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/eye-dryness? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/eye-dryness? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/yes)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "eye-dryness"
                      :checked   (false? (get-in @state [:consult :consult/eye-dryness? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/eye-dryness? :value])
                                         new-value (when (-> e .-target .-checked) false)
                                         changed?  (or (get-in @state [:consult :consult/eye-dryness? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/eye-dryness? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/eye-dryness? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/eye-dryness? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/no)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The eye dryness step"
  [state nav-fn]
  [:div.card-content
   ;; statement
   [statement]
   ;; field
   [eye-dryness-field state]
   [:hr]
   ;; navigation
   [navigation state nav-fn]])
